import GetIcon16ByName from '@bimser/icons/lib/getIcon16ByName';
import React from 'react';

const containerStyle: React.CSSProperties = {
	display: 'flex',
	alignItems: 'center',
	columnGap: '10px'
};

const titleStyle: React.CSSProperties = {
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis'
};

export const iconTextRenderer = (text?: string, iconName?: string) => {
	let icon = null;

	if (iconName) {
		const Icon = GetIcon16ByName(iconName);

		if (Icon) {
			icon = <Icon width="auto" />;
		}
	}

	return (
		<div
			title={text}
			style={containerStyle}
		>
			{icon}
			<span style={titleStyle}>{text}</span>
		</div>
	);
};
